export default "__VITE_ASSET__D8sCO_OC__"